<template>
  <div class="promotionGood" v-if="benefit.length > 0">
    <router-link
      :to="{ path: item.stock > 0 ? '/detail/' + item.id : $route.fullPath }"
      class="item acea-row row-between-wrapper"
      :class="item.stock > 0 ? '' : 'noStock'"
      v-for="(item, index) in benefit"
      :key="index"
    >
      <div class="pictrue">
        <img :src="item.image" class="image" />
      </div>
      <div class="text">
        <div class="name line1">{{ item.storeName }}</div>
        <div class="sp-money acea-row">
          <div class="moneyCon">
            促销价:
            <span class="num">{{ item.price }}</span>
            <span class="integral">积分</span>
          </div>
        </div>
        <!-- <div class="acea-row row-between-wrapper">
          <div class="money">日常价：{{ item.otPrice }} 积分</div>
          <div>仅剩：{{ item.stock }}{{ item.unitName }}</div>
        </div> -->
      </div>
      <div v-if="item.stock <= 0" class="noselling">
        无&nbsp;货
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "PromotionGood",
  props: {
    benefit: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {};
  }
};
</script>
